(function ($) {


  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */

  var $markers
  let infowindows = []
  var map
  // console.log(google.maps.places)

  function initMap($el) {
    // Find marker elements within map.
    $markers = $el.find(".marker");

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: false,
      disableDefaultUI: true,
      styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#c9c9c9"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ]
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var postId = $marker.data("id");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    const icon = {
      // url: seize_data.site_url + "/wp-content/uploads/loc-pin.svg", // url
      url: seize_data.site_url + "/content/uploads/loc-pin.svg", // url
      scaledSize: new google.maps.Size(40, 40), // scaled size
      origin: new google.maps.Point(0, 0), // origin


    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: icon,
      postId: postId,
    });

    // Append to reference for later use.
    map.markers.push(marker);
    // console.log(map)

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });



      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, "click", function () {
        if ($('.form-slides__map').length > 0) {

          let id = this.postId


          $.ajax({
            url: seize_data.ajaxUrl, // This variable is defined by WordPress and points to admin-ajax.php
            type: 'POST',
            data: {
              action: 'get_installateur_form',
              id: id,
            },
            dataType: 'json',
            success: function (response) {
              console.log(response)
              $('.popup-install').html(response)
              $('.seize-popup').addClass('active')
            }
          })
        } else {


          if (infowindows.length > 0) {


            for (var i = 0; i < infowindows.length; i++) {

              infowindows[i].close();
            }

          }
          infowindow.open(map, marker);
          infowindows.push(infowindow);
        }




      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  function zoomToPostalCode(postalCode) {
    // create a geocoder object to convert the postal code to coordinates
    var geocoder = new google.maps.Geocoder();
    // var map = new google.maps.Map($(".acf-map").get(0));


    // use the geocoder object to convert the postal code to coordinates
    geocoder.geocode({ address: postalCode }, function (results, status) {

      if (status === "OK") {
        // if the geocoder was able to find a location for the postal code, get the coordinates
        var location = results[0].geometry.location;

        // center the map on the location and zoom in
        map.setCenter(location);
        map.setZoom(9);

        $markers.each(function () {
          initMarker($(this), map);

        });

      } else {
        // if the geocoder couldn't find a location for the postal code, display an error message
        console.log(
          "Geocode was not successful for the following reason: " + status
        );
      }
    });
  }

  // Render maps on page load.
  $(document).ready(function () {




    $(".acf-map").each(function () {

      map = initMap($(this));
    });

  });



  


  //   var markerClusterer = new MarkerClusterer(map, markers, {
  //     gridSize: 50,
  //     zoomOnClick: true,
  //     minimumClusterSize: 2,
  //     imagePath:
  //       "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
  //   });

  //   // set up an event listener to redraw the clusters when the map is zoomed
  //   google.maps.event.addListener(
  //     google.maps.Map($(".acf-map").get(0)),
  //     "zoom_changed",
  //     function () {
  //       markerClusterer.repaint();
  //     }
  //   );
  const stateSelect = $(".select-state");
  const stateOptionsList = stateSelect.find(".options");
  const stateCheckboxes = stateSelect.find('input[type="checkbox"]');

  // stateCheckboxes.addEventListener('change', () => {
  //   const selectedDepartment = departmentSelector.value;
  //   // Call a function to center the map on the selected department
  //   centerMapOnDepartment(map, $(this).val());
  // });
  const autocompleteInputs = document.querySelectorAll('.select-city__input');

  autocompleteInputs.forEach(input => {
    const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ['geocode'], // You can use 'geocode' type to get location-based results
      componentRestrictions: { country: 'FR' } // Restrict results to France (FR)
    });

    setTimeout(() => {
      const inputRect = input.getBoundingClientRect();
      const pac = document.querySelector('.pac-container');
  
      if (pac) {
        pac.style.position = 'absolute';
        pac.style.top = `${inputRect.bottom + window.scrollY}px`;
        pac.style.left = `${inputRect.left + window.scrollX}px`;
        pac.style.width = `${inputRect.width}px`;
        pac.style.zIndex = 9999;
      }
    }, 300);
    autocomplete.addListener('place_changed', () => {
      const statePlaceholder = stateSelect.find(".select-box__placeholder");
      const place = autocomplete.getPlace();
      $('.select-state .options input[type="checkbox"]').prop('checked', false)

      statePlaceholder.text("Sélectionner votre région");


      if (place.geometry) {
        map.setCenter(place.geometry.location);
        map.setZoom(12); // Adjust the zoom level as needed
      }
      // Get the selected city's coordinates
      const selectedCityCoordinates = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      let closestMarker = null;
      let closestDistance = Number.MAX_VALUE;
      const closestMarkers = [];
      let zoomLevel

      let list_markers = []
      $markers.each(function () {


        var lat = $(this).data("lat");
        var lng = $(this).data("lng");
        var name = $(this).data("slug");
        var latLng = {
          lat: parseFloat(lat),
          lng: parseFloat(lng),
          name
        };
        list_markers.push(latLng)
      })

      list_markers.forEach(marker => {
        const markerCoordinates = new google.maps.LatLng(marker.lat, marker.lng);
        const distance = google.maps.geometry.spherical.computeDistanceBetween(selectedCityCoordinates, markerCoordinates);

        closestMarkers.push({ name: marker.name, distance });

        if (distance < closestDistance) {
          closestDistance = distance;
          closestMarker = markerCoordinates;
        }

        if (closestMarker) {

          map.setCenter(selectedCityCoordinates);
          // Calculate an appropriate zoom level based on the distance

        }
      });
      closestMarkers.sort((a, b) => a.distance - b.distance);
      const closestMarkerNames = closestMarkers.slice(0, 3).map(marker => marker.name);

      $installateur_list = $('.installateur-list')
      $installateur_list.addClass('inactive')

      jQuery.ajax({
        type: 'POST',
        url: seize_data.ajaxUrl,
        data: {
          action: 'get_marker_posts', // The WordPress AJAX action hook
          closestMarkerNames: closestMarkerNames,
        },
        dataType: 'json',
        success: function (response) {

          $installateur_list.empty()
          $.each(response, function (index, single) {
            if (!single.term) {
              single.term = ''
            }
            if ($('.form-slides__map').length > 0) {
              console.log(single.name)
              $installateur_list.append('<div class="installateur-list__single"><a class="open-pop" data-id="' + single.id + '"><h2>' + single.name + '</h2><hr><p class="installateur-list__single-city">' + single.term + '</p></a></div>')

            } else {
              $installateur_list.append('<div class="installateur-list__single"><a href="' + single.permalink + '"><h2>' + single.name + '</h2><hr><p class="installateur-list__single-city">' + single.term + '</p></a></div>')
            }

          })
          $installateur_list.removeClass('inactive')
        },
        error: function (error) {
          console.log('AJAX error:', error);
        }
      });


      zoomLevel = calculateZoomLevel(closestDistance);

      map.setZoom(zoomLevel);


    });
  });


  $('.select-state .options input').on('click', function () {
    const checkboxes = $('.select-state .options input');
    const allUnchecked = checkboxes.filter(':checked').length === 0;

    if (allUnchecked) {
      map.setZoom(6)
    } else {

      const selectedStateCoordinates = {
        lat: $(this).data('lat'),
        lng: $(this).data('long')
      };
      map.setCenter(selectedStateCoordinates);
      map.setZoom(8);
    }
  })

  // Listen for place selection


  function calculateZoomLevel(distance) {
    // You can adjust this formula to fit your specific needs
    // This example uses a linear interpolation based on distance
    const maxDistance = 2000000; // Maximum distance (adjust as needed)
    const maxZoomLevel = 9; // Maximum zoom level (adjust as needed)
    const minZoomLevel = 4; // Minimum zoom level (adjust as needed)

    if (distance <= maxDistance) {
      // Linear interpolation to calculate zoom level
      const zoomLevel = maxZoomLevel - (distance / maxDistance) * (maxZoomLevel - minZoomLevel);
      return Math.round(zoomLevel);
    }

    return minZoomLevel;
  }



  function centerMapOnDepartment(map, selectedDepartment) {
    // Replace these coordinates with the coordinates of your departments or states
    const departmentCoordinates = {
      department1: { lat: 41.8781, lng: -87.6298 }, // Example coordinates for Department 1
      department2: { lat: 34.0522, lng: -118.2437 }, // Example coordinates for Department 2
    };

    if (departmentCoordinates[selectedDepartment]) {
      map.setCenter(departmentCoordinates[selectedDepartment]);
      map.setZoom(10); // You can adjust the zoom level as needed
    }
  }


  $("#input-postal").on("input", function (e) {

    if ($(this).val().length == 5) {
      zoomToPostalCode($(this).val());
    }
  });


})(jQuery);
